import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AddressAddressee } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class AddressAddresseeService extends TmsWebBaseEditCreateService<AddressAddressee, AddressAddressee> {
  constructor() {
    super('AddressAddressee', $localize`Address Addressee`);
  }

  getForAddress(id: string): Observable<AddressAddressee[]> {
    return this.httpService.get<AddressAddressee[]>(`${this.apiUrl}/AddresseesForAddress?id=${id}`);
  }
}
